function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext, useEffect, useRef, useState, useCallback } from 'react';
import { isMacOs } from 'react-device-detect';
import EditorContext from '../store/Editor.context';
var options = {
  query: '',
  caseSensitive: false,
  findPrevious: undefined,
  highlightAll: true,
  phraseSearch: true,
  entireWord: false
};

var EditorSearchBar = function EditorSearchBar(_ref) {
  var refPdf = _ref.refPdf;
  var findController = useRef(null);
  var inputRef = useRef(null);
  var menuRef = useRef(null);

  var _useContext = useContext(EditorContext),
      state = _useContext.state;

  var _useState = useState({}),
      _useState$ = _useState[0],
      _useState$$current = _useState$.current,
      current = _useState$$current === void 0 ? 0 : _useState$$current,
      _useState$$total = _useState$.total,
      total = _useState$$total === void 0 ? 0 : _useState$$total,
      setMatches = _useState[1];

  var _useState2 = useState(''),
      value = _useState2[0],
      setValue = _useState2[1];

  var dispatchEvent = function dispatchEvent(type, findPrevious) {
    if (findController.current) {
      findController.current.executeCommand("find" + type, _extends({}, options, {
        findPrevious: findPrevious
      }));
    }
  };

  var handleClear = function handleClear() {
    options.query = '';
    setMatches({});
    dispatchEvent('');
    setValue('');
  };

  var searchListener = useCallback(function (e) {
    if (e.keyCode === 70 && (isMacOs ? e.metaKey : e.ctrlKey)) {
      e.preventDefault();
      e.stopPropagation();
      inputRef.current.focus();
    } else if (e.keyCode === 27) {
      e.preventDefault();
      handleClear();
      inputRef.current.blur();
    }
  }, []);

  var handleMatches = function handleMatches(_ref2) {
    var matchesCount = _ref2.matchesCount,
        source = _ref2.source;

    if (current !== matchesCount.current || total !== matchesCount.total) {
      setMatches(matchesCount);
    } else if (!source._matchesCountTotal) {
      setMatches({});
    }
  };

  useEffect(function () {
    if (state.mounted && refPdf.current) {
      findController.current = refPdf.current.viewer.findController;

      findController.current._eventBus.on('updatefindmatchescount', handleMatches);

      findController.current._eventBus.on('updatefindcontrolstate', handleMatches);

      findController.current._eventBus.on('findbarclose', function (props) {
        return console.log('props', props);
      });

      window.addEventListener('keydown', searchListener);
    }

    return function () {
      window.removeEventListener('keydown', searchListener);
    };
  }, [state.mounted]);

  var handleSearch = function handleSearch(e) {
    if (!e.target.value) {
      setMatches({});
    }

    options.query = e.target.value;
    dispatchEvent('');
    setValue(e.target.value);
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === 13) {
      dispatchEvent('again', e.shiftKey);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "relative rounded-md border-2 flex z-20",
    ref: menuRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    className: "h-5 w-5 text-gray-800"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
  }))), /*#__PURE__*/React.createElement("input", {
    disabled: state.processing,
    id: "search",
    ref: inputRef,
    style: {
      minWidth: 200,
      width: 200
    },
    className: "form-input block pl-10 pr-6 h-8 bg-gray-300 text-gray-800 disabled:opacity-50",
    placeholder: "Find in document",
    autoComplete: "off",
    onChange: handleSearch,
    onKeyDown: handleKeyDown,
    value: value
  }), !!value && /*#__PURE__*/React.createElement("div", {
    className: "absolute right-0 px-1 h-full flex items-center"
  }, /*#__PURE__*/React.createElement("button", {
    className: "bg-transparent hover:bg-gray-400 transition-colors text-gray-800 p-1 rounded-full inline-flex items-center focus:outline-none",
    onClick: handleClear
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    className: "h-4 w-4"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M6 18L18 6M6 6l12 12"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "flex h-full items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-3 flex flex-grow items-center text-sm"
  }, current, "/", total), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col mr-1"
  }, /*#__PURE__*/React.createElement("button", {
    className: "hover:text-primary text-gray-800 rounded-full inline-flex items-center focus:outline-none disabled:text-gray-400",
    disabled: !total,
    onClick: function onClick() {
      return dispatchEvent('again', true);
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    className: "h-4 w-4"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M5 15l7-7 7 7"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "hover:text-primary text-gray-800 rounded-full inline-flex items-center focus:outline-none disabled:text-gray-400",
    disabled: !total,
    onClick: function onClick() {
      return dispatchEvent('again', false);
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    className: "h-4 w-4"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M19 9l-7 7-7-7"
  }))))));
};

export default EditorSearchBar;